/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { LiveblocksControllerResolveUsersMutationResponse, LiveblocksControllerResolveUsers401, LiveblocksControllerResolveUsers403 } from "../../models/liveblocksController/LiveblocksControllerResolveUsers";

function getLiveblocksControllerResolveUsersUrl() {
  const res = { method: 'POST', url: `/api/v1/liveblocks/resolve-users` as const }  
  return res
}

/**
 * @summary Resolve user display info from user IDs
 * {@link /api/v1/liveblocks/resolve-users}
 */
export async function liveblocksControllerResolveUsers(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<LiveblocksControllerResolveUsersMutationResponse, ResponseErrorConfig<LiveblocksControllerResolveUsers401 | LiveblocksControllerResolveUsers403>, unknown>({ method : "POST", url : getLiveblocksControllerResolveUsersUrl().url.toString(), ... requestConfig })  
  return res.data
}